// extracted by mini-css-extract-plugin
module.exports = {"chat":"Chat_chat__y7smQ","messageInputWrapper":"Chat_messageInputWrapper__1yg7G","buttonsWrapper":"Chat_buttonsWrapper__3evJ4","messagesWrapper":"Chat_messagesWrapper__1QqIb"};